var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalysisFailed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 141,
    viewBox: "0 0 166 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_450_5901)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.46 116.41C6.34 116.41 3 113.07 3 108.95V10.5498C3 6.42984 6.34 3.08984 10.46 3.08984H155.53C159.65 3.08984 162.99 6.42984 162.99 10.5498V107.26C162.99 107.26 163.28 116.4 154.2 116.4",
    stroke: "#B8B5DD",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 64C71.429 64 62 73.429 62 85C62 96.571 71.429 106 83 106C94.571 106 104 96.571 104 85C104 73.429 94.571 64 83 64ZM83 101.8C73.739 101.8 66.2 94.261 66.2 85C66.2 75.739 73.739 68.2 83 68.2C92.261 68.2 99.8 75.739 99.8 85C99.8 94.261 92.261 101.8 83 101.8Z",
    fill: "#BE0611"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3208 78L83 82.3396L78.6792 78L76 80.6792L80.3396 85L76 89.3208L78.6792 92L83 87.6604L87.3208 92L90 89.3208L85.6604 85L90 80.6792L87.3208 78Z",
    fill: "#BE0611"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.04 15.8999H21V22.4399H36.04V15.8999Z",
    stroke: "#4230E5",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.72 15.8999H47.68V22.4399H62.72V15.8999Z",
    stroke: "#B8B5DD",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4 15.8999H74.36V22.4399H89.4V15.8999Z",
    stroke: "#B8B5DD",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.07 15.8999H101.03V22.4399H116.07V15.8999Z",
    stroke: "#B8B5DD",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145 33.3799H21V137.91H145V33.3799Z",
    stroke: "#B8B5DD",
    strokeWidth: 5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_450_5901"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 165,
    height: 139.82,
    fill: "white",
    transform: "translate(0.5 0.589844)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysisFailed);
export default __webpack_public_path__ + "static/media/analysis-failed.a8f7590b702a734c6a8ef7e363556ffd.svg";
export { ForwardRef as ReactComponent };